module.exports = __webpack_public_path__ + "img/revocation.8bb518e1.svg";